/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import Calendar from '../../../assets/images/boletim/calendar.svg';
import Printer from '../../../assets/images/boletim/printer.svg';
import Unlock from '../../../assets/images/boletim/unlock.svg';

const TicketPayment = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="mb-4">
            <div className="card-body">
              {/* <SubscriptionPaymentConditionInstallmentsFields
            paymentConditions={this.props.parcelamentos}
            onChangeSelected={this.props.opcaoParcelamentoSelecionada}
            vendaAtual={this.props.vendaAtual}
            incomeValue={this.props.incomeValue}
          /> */}
              <p>
                <img src={Calendar} width="20px" /> Você tem 3 dias para efetuar o pagamento
              </p>
              <p>
                <img src={Printer} width="20px" /> Imprima seu boleto ou pague pela internet
              </p>
              <p>
                <img src={Unlock} width="20px" /> Sua assinatura será ativada automaticamente
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketPayment;
